export default __webpack_public_path__ + "static/media/6.6425e26e.jpg";